var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary","fixed":"","dark":"","fab":"","bottom":"","right":""},on:{"click":function($event){return _vm.chamarAttemics()}}},[_c('v-icon',[_vm._v("mdi-chat")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }